import { RuleTypes } from '@src/api/selection';
import { FC } from 'react';
import { PatientAgeRule } from '../PatientAgeRule';
import { PatientBirthSexRule } from '../PatientBirthSexRule';
import { ResultValueRule } from '../ResultValueRule/ResultValueRule';
import { ResultRefValueRule } from '../ResultRefValueRule';
import { MissingResultRule } from '../MissingResultRule';
import { DiagnosesRule } from '../DiagnosesRule';

type RuleFactoryProps = {
  ruleType: RuleTypes | string;
  prefix: string;
  children: JSX.Element;
  dataTestId?: string;
};

export const RuleFactory: FC<RuleFactoryProps> = ({ ruleType, prefix, children, dataTestId }) => {
  switch (ruleType) {
    case RuleTypes.PatientAgeRule: {
      return <PatientAgeRule prefix={prefix} children={children} dataTestId={dataTestId} />;
    }
    case RuleTypes.PatientBirthSexRule: {
      return <PatientBirthSexRule prefix={prefix} children={children} dataTestId={dataTestId} />;
    }
    case RuleTypes.ResultRefValueRule: {
      return <ResultRefValueRule prefix={prefix} children={children} dataTestId={dataTestId} />;
    }
    case RuleTypes.ResultRule: {
      return <ResultValueRule prefix={prefix} children={children} dataTestId={dataTestId} />;
    }
    case RuleTypes.MissingResultRule: {
      return <MissingResultRule prefix={prefix} children={children} dataTestId={dataTestId} />;
    }
    case RuleTypes.ConditionAndDiagnosisRule: {
      return <DiagnosesRule prefix={prefix} children={children} />;
    }

    default: {
      return <></>;
    }
  }
};
